/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import "./EditableDropdown.scss";
import { Iconify } from "@repo/design-system/components/ui";
import { sentenceCase } from '@repo/design-system/components/forms/utils';

import Input from '../input/Input';
import Dropdown from '../dropdown/DropDown';

const EditableDropdown = ({
  onChange,
  onBlur,
  dataField,
  value,
  formSetting,
  options,
  placeholder,
  fieldActions,
  isMultiSelect,
  isText,
  onActionChange,
  ...inputProps
}) => {


  const [isInputField, setIsInputField] = useState(isText);

  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e.target.value, 'input');
    }
  };

  useEffect(() => {
    if (value === null || value === "") {
      setIsInputField(false);
    }
  }, [value]);

  const handleInputFields = () => {
    setIsInputField(!isInputField);
    if (onActionChange) {
      onActionChange("DAL_CHANGED", dataField, !isInputField);
    }
  }

  const handleChange = (selectedOption) => {
    if (onChange) {
      if (isMultiSelect) {
        const selectedValues = selectedOption.map((option) => option.value);
        onChange(dataField, 'dropdown', selectedValues);
      } else {
        onChange(dataField, "dropdown", selectedOption);
        if (fieldActions) {
          fieldActions("DDL_CHANGED", dataField, selectedOption);
        }
      }
    }
  };

  const handleOnBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };



  return (
    <div className="custom-dropdown">
      <div className="input-sec">
        {!isInputField ? (
          <Dropdown
            placeholder={sentenceCase(placeholder)}
            onChange={handleChange}
            onBlur={handleOnBlur}
            options={options}
            value={value}
            isMultiSelect={isMultiSelect}
            isDisabled={formSetting?.isViewOnly || inputProps.isDisable}
            {...inputProps}
          />
        ) : (
          <Input
            placeholder={placeholder}
            onChange={handleInputChange}
            onBlur={handleOnBlur}
            value={value ? value.text : ""}
            isDisable={formSetting?.isViewOnly || inputProps?.isDisable || false}
            {...inputProps}
          />
        )}
      </div>
      <button className="button-sec" style={{ background: 'unset', border: 'unset' }}
        onClick={() => handleInputFields()}>
        <div title={!isInputField ? "Edit" : "Cancel"}>
          <Iconify icon={!isInputField ? "mdi:pencil-outline" : "iconoir:cancel"} />
        </div>
      </button>
    </div>
  );
};

EditableDropdown.propTypes = {
  onActionChange: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  dataField: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  placeholder: PropTypes.string,
  fieldActions: PropTypes.func,
  isMultiSelect: PropTypes.bool,
  isText: PropTypes.bool,
  inputProps: PropTypes.object
};


export default EditableDropdown;
